import { connect } from 'react-redux'
import GoingLiveModal from './GoingLiveModal'
import { status as statuses } from '@bt-react/constants'

const mapStateToProps = state => ({
  isLive: state.ui.isLive,
  isCountingDown: state.ui.status === statuses.PRE_ROLL_INTERSTITIAL
})

export default connect(mapStateToProps)(GoingLiveModal)
